import { useSortable } from "@dnd-kit/sortable"
import { CSS } from "@dnd-kit/utilities"
import { ReactNode } from "react"

interface SortableItemProps {
    id: string
    children: (props: { listeners: any }) => ReactNode
}

export function SortableItem({ id, children }: SortableItemProps) {
  const { attributes, listeners, setNodeRef, transform, transition } = 
    useSortable({ id }) 
    
  const style: React.CSSProperties = { 
    transform: CSS.Transform.toString(transform), 
    transition: transition || "transform 150ms ease", 
  } 
  
  return ( 
    <div ref={setNodeRef} style={style} {...attributes}> 
      {children({ listeners })} 
    </div> 
  )
}
